import request from "../../utils/request";
export default {
  campaignItem: function campaignItem(campaignDefinitionId) {
    return request('get', 'api/f/v1/onlinebranch/campaigndefinitionbyid?campaignDefinitionId=' + campaignDefinitionId);
  },
  campaignList: function campaignList(options) {
    return request('post', 'api/f/v1/onlinebranch/campaigns/', options);
  },
  customerTransactions: function customerTransactions(showAll, productCode, startDate, endDate) {
    return request('get', 'api/f/v1/onlinebranch/customertransactions?showAll=' + showAll + '&productCode=' + productCode + '&startDate=' + startDate + '&endDate=' + endDate);
  },
  lastUnpaidDebts: function lastUnpaidDebts() {
    return request('get', 'api/f/v1/onlinebranch/lastunpaiddebts');
  },
  paymentPlans: function paymentPlans(calculationId) {
    // payment.js -> getpaymentplans()
    return request('get', 'api/f/v1/onlinebranch/paymentplans?calculationId=' + calculationId);
  },
  productCardDetails: function productCardDetails(calculationId) {
    // product.js -> getProductCardList()
    return request('get', 'api/f/v1/onlinebranch/productcarddetails?calculationId=' + calculationId);
  },
  productList: function productList() {
    return request('get', 'api/f/v1/onlinebranch/productlist');
  },
  productListInternetBranch: function productListInternetBranch() {
    return request('get', 'api/f/v1/onlinebranch/productlistinternetbranch');
  },
  getProductDetails: function getProductDetails(identificationNumber, productCode) {
    return request('get', 'api/f/v1/onlinebranch/getproductdetails?identificationNumber=' + identificationNumber + '&productCode=' + productCode);
  },
  drawingListByProductId: function drawingListByProductId(productId) {
    // draw.js -> getdrawinglistbyproductid
    return request('get', 'api/f/v1/onlinebranch/drawinglistbyproductId?productId=' + productId);
  },
  totalPaymentInformationByProductId: function totalPaymentInformationByProductId(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/totalPaymentInformationByProductId?calculationId=' + calculationId);
  },
  deliveryCounter: function deliveryCounter() {
    return request('get', 'api/f/v1/onlinebranch/deliverycounter');
  },
  customerDetails: function customerDetails() {
    // product.js -> getcustomerdetails
    return request('get', 'api/f/v1/onlinebranch/customerdetails');
  },
  customerFuturePayments: function customerFuturePayments() {
    return request('get', 'api/f/v1/onlinebranch/customerFuturePayments');
  },
  paymentProcess: function paymentProcess(viewModel) {
    return request('post', 'api/f/v1/onlinebranch/paymentprocess', viewModel);
  },
  productCodes: function productCodes() {
    return request('get', 'api/f/v1/onlinebranch/productcodes');
  },
  getLastUnpaidDebtForProduct: function getLastUnpaidDebtForProduct(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/lastunpaiddebtforproduct?calculationId=' + calculationId);
  },
  getBlockedFund: function getBlockedFund(productId) {
    return request('get', 'api/f/v1/onlinebranch/blockedfund?productId=' + productId);
  },
  getAnotherChanceApplicationStatus: function getAnotherChanceApplicationStatus(productId) {
    return request('get', 'api/f/v1/onlinebranch/anotherchanceapplicationstatus?productId=' + productId);
  },
  hpmPost: function hpmPost(paymentModel) {
    return request('post', 'api/f/v1/onlinebranch/hpmpaymentrequest', paymentModel);
  },
  paymentRequest: function paymentRequest(paymentModel) {
    return request('post', 'api/f/v1/onlinebranch/paymentrequest', paymentModel);
  },
  // paymentsmsnotification() { Ödeme sonrası SMS
  //   return request('get', 'api/f/v1/onlinebranch/productcodes')
  // },
  changePaymentDate: function changePaymentDate(model) {
    return request('post', 'api/f/v1/onlinebranch/paymentdatechange', model);
  },
  getCustomerName: function getCustomerName(productInfo) {
    return request('get', 'api/f/v1/onlinebranch/customerinfo?productinfo=' + productInfo);
  },
  attendSavingFestivalCampaignAsync: function attendSavingFestivalCampaignAsync(model) {
    return request('post', 'api/f/v1/onlinebranch/attendsavingfestivalcampaign', model);
  },
  attendCollectionCampaignAsync: function attendCollectionCampaignAsync(model) {
    return request('post', 'api/f/v1/onlinebranch/attendcollectioncampaign', model);
  },
  getSavingFestivalCampaignStatusAsync: function getSavingFestivalCampaignStatusAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/savingfestivalcampaignstatusbyid?calculationid=' + calculationId);
  },
  getSpecialCampaingParameterByIdAsync: function getSpecialCampaingParameterByIdAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/specialcampaingparameterbyid?calculationid=' + calculationId);
  },
  getCollectionCampaignStatusAsync: function getCollectionCampaignStatusAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/collectioncampaignstatusbyid?calculationid=' + calculationId);
  },
  getSavingFestivalCampaignCustomerInfoAsync: function getSavingFestivalCampaignCustomerInfoAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/savingfestivalcampaigncustomerinfobyid?calculationid=' + calculationId);
  },
  getCollectionCampaignCustomerInfoAsync: function getCollectionCampaignCustomerInfoAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/collectioncampaigncustomerinfobyid?calculationid=' + calculationId);
  },
  getSavingFestivalJuneCampaignCustomerInfoAsync: function getSavingFestivalJuneCampaignCustomerInfoAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/savingfestivaljunecampaigncustomerinfobyid?calculationid=' + calculationId);
  },
  attendWorkingCostCampaignServiceAsync: function attendWorkingCostCampaignServiceAsync(model) {
    return request('post', 'api/f/v1/onlinebranch/attendworkingcostcampaign', model);
  },
  getWorkingCostCampaignStatusAsync: function getWorkingCostCampaignStatusAsync(calculationId) {
    return request('get', 'api/f/v1/onlinebranch/workingcostcampaignstatusbyid?calculationid=' + calculationId);
  }
};